import React, {useEffect, useState} from 'react';
import TextField from "@mui/material/TextField";
import styles from './Decloration.module.css'
import Button from "@mui/material/Button";
import {useNavigate} from "react-router-dom";
import {useDispatch, useSelector} from "react-redux";
import {fetchApplications, fetchApplicationTypes, fetchDrafts, setFulledFields} from "./declarationSlice";
import DeclarationModal from "./DeclarationModal";
import DeclarationList from "./DeclarationList";
import DraftList from "./DraftList";
import Typography from "@mui/material/Typography";
import Divider from "@mui/material/Divider";

function DeclarationFp(props) {
    const navigate = useNavigate()
    const dispatch = useDispatch()
    const types = useSelector(state => state.declarationSlice.applicationTypes)
    console.log(types)
    const applications = useSelector(state => state.declarationSlice.applications)
    const drafts = useSelector(state => state.declarationSlice.drafts)
    const [values, setValues] = useState('');
    const [modalVisible, setModalVisible] = useState(false)
    const [fieldValues, setFieldValues] = useState([]);
    
    const handleClick = () => {
        // Navigate to type selection page instead of showing modal
        navigate('/declaration/select-type');
    };

    const handleChange = (index, value, name) => {
        const newValues = [...fieldValues];
        newValues[index] = {name: name, value: value,};
        setFieldValues(newValues);
        setModalVisible(false)
    };

    useEffect(() => {
        dispatch(fetchApplicationTypes())
        dispatch(fetchApplications())
        dispatch(fetchDrafts())
    }, [])
    return (
        <div className='content-wrapper'>
            <div className="page-title-container">
                <h1 className="page-title ">
                    Заявления
                </h1>
            </div>

            <div className={styles.declarationBody}>
                {/* Drafts Section */}
                {drafts?.length > 0 && (
                    <>
                        <Typography variant="h6" sx={{ mb: 2, mt: 2, fontWeight: 600 }}>
                            Черновики
                        </Typography>
                        {drafts.map(draft => (
                            <DraftList key={draft.id} draft={draft} applicationTypes={types} />
                        ))}
                        <Divider sx={{ my: 3 }} />
                    </>
                )}

                {/* Applications Section */}
                <Typography variant="h6" sx={{ mb: 2, mt: drafts?.length > 0 ? 0 : 2, fontWeight: 600 }}>
                    Заявления
                </Typography>
                {applications?.length ? (
                    applications.map(declaration => (
                        <DeclarationList key={declaration.id} declaration={declaration} />
                    ))
                ) : (
                    <Typography variant="body2" color="text.secondary" sx={{ mb: 2 }}>
                        Заявлений пока нет
                    </Typography>
                )}
                
                <div className={styles.goToDeclarations}>
                    <Button
                        className={styles.button + ' ' + styles.orange}
                        onClick={handleClick}
                    >
                        Создать заявление
                    </Button>
                </div>
            </div>
        </div>
        // </section>
    );
}

export default DeclarationFp;